// extracted by mini-css-extract-plugin
export var divider = "_l6-0";
export var systemMessage = "_l6-1";